// @flow

// useSizeUpdates takes an element ref and a callback function. After a render
// (initial or subsequent), the new component size is passed to the callback.
// This callback is only called when the size changes (and always on first
// render).

import { useRef, useEffect } from 'react';

export type onSizeUpdatedCallback = ({ width: number, height: number }) => void;

// TODO (rjames): tests for this function
export default function useSizeUpdates(
  elementToObserve: { current: ?HTMLDivElement },
  onSizeUpdated: ?onSizeUpdatedCallback,
) {
  const componentSize = useRef<?{ width: number, height: number }>();

  useEffect(() => {
    const container = elementToObserve.current;
    if (!container) {
      return;
    }

    const currentSize = componentSize.current;
    if (
      !currentSize ||
      currentSize.width !== container.offsetWidth ||
      currentSize.height !== container.offsetHeight
    ) {
      componentSize.current = {
        width: container.offsetWidth || 0,
        height: container.offsetHeight || 0,
      };

      if (onSizeUpdated) {
        onSizeUpdated(componentSize.current);
      }
    }
  });

  return componentSize.current;
}
